import type { AppConfiguration } from '@ori/favorites-context';
import { ConfigurationProvider } from '@ori/favorites-context';
import { ErrorBoundary } from '@ori/presentation-components';

import { FavoritesProvider } from './components';
import { ApiProvider } from './containers';

export interface AppProps {
  configuration: AppConfiguration;
}

export const App = ({ configuration }: AppProps) => (
  <ErrorBoundary>
    <ConfigurationProvider value={configuration}>
      <ApiProvider>
        <FavoritesProvider />
      </ApiProvider>
    </ConfigurationProvider>
  </ErrorBoundary>
);
